/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  headshotContainer: css`
    margin-bottom: 50px;
  `,
  headshotBubble: (image: string) => css`
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 3px solid var(--cds-color-white-0);
    box-shadow: var(--cds-color-grey-100) 0 3px 30px;
    background-image: url(${image});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  `,
};

type Props = {
  imageUrl?: string | null;
  name?: string | null;
  countryName?: string | null;
  index: number;
};

const TestimonialHeadshot = ({ name, imageUrl, countryName, index }: Props) => {
  if (!imageUrl || !name) {
    return null;
  }

  return (
    <div
      key={name}
      css={styles.headshotContainer}
      style={{
        alignSelf: index % 2 === 0 ? 'flex-end' : 'flex-start',
      }}
    >
      <div css={styles.headshotBubble(imageUrl)} />
      <Typography2 component="p" variant="bodySecondary" color="supportText" align="center" css={{ fontWeight: 700 }}>
        {name}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText" align="center">
        {countryName}
      </Typography2>
    </div>
  );
};

export default TestimonialHeadshot;
